module.exports = __webpack_public_path__ + "static/media/bullet_icon.ef5a4e25.svg";